// Module
var code = "<textarea ui-tinymce=\"to.tinyMceOptions\" ng-model=\"model[options.key]\"></textarea>";
// Exports
export default code;